/* WoodenCrew custom JS — moved from Vitals "Custom JS" (2026-10-16).
 * Same logic as the Vitals jQuery code, rewritten in plain JS (the theme has no jQuery).
 * Safety: while the same code is still saved in Vitals, this file does nothing,
 * so the code never runs twice. After the Vitals field is cleared, this file takes over.
 */
(function () {
  'use strict';
  if (window.__wcCustomJs) return;
  window.__wcCustomJs = true;

  function vitalsHasOldCode() {
    var el = document.getElementById('vtlsAebDynamicFunctions');
    return !!(el && el.textContent.indexOf('Backup redirect customer to /cart') !== -1);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function onLoad(fn) {
    if (document.readyState === 'complete') fn();
    else window.addEventListener('load', fn);
  }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  // like jQuery $(el).find(sel): every part of the selector must be inside el
  function find(el, sel) {
    var scoped = sel.split(',').map(function (s) { return ':scope ' + s.trim(); }).join(',');
    return $$(scoped, el);
  }
  // like jQuery .text() on a collection: joined text of all matched elements
  function textOf(els) {
    return els.map(function (e) { return e.textContent; }).join('');
  }
  function hide(els) { els.forEach(function (e) { e.style.display = 'none'; }); }
  // like jQuery .show()
  function show(els) {
    els.forEach(function (e) {
      e.style.display = '';
      if (getComputedStyle(e).display === 'none') {
        var t = document.createElement(e.nodeName);
        document.body.appendChild(t);
        var d = getComputedStyle(t).display;
        t.remove();
        e.style.display = d === 'none' ? 'block' : d;
      }
    });
  }

  function start() {
    if (vitalsHasOldCode()) return;

    /* Currency name for AUD, CAD, NZD */
    ready(function () {
      setTimeout(function () {
        var c = window.Shopify && Shopify.currency && Shopify.currency.active;
        if (c === 'AUD' || c === 'CAD' || c === 'NZD') {
          $$('.price, .special-price, .money').forEach(function (el) {
            if (!el.querySelector('.currency-name')) {
              el.insertAdjacentHTML('beforeend', '<span class="currency-name"> ' + c + '</span>');
            }
          });
        }
      }, 1000);
    });

    /* Tracking page updates (Track123) */
    ready(function () {
      setTimeout(function () {
        $$('#track123-powered-by').forEach(function (e) { e.remove(); });
        var no = document.querySelector('.track123_order_tracing_no.track123_track_no_info');
        var title = document.getElementById('track123_order_detail_title');
        if (no && title) title.insertAdjacentHTML('beforeend', '  👉' + no.outerHTML);
      }, 2000);
    });

    /* Add doubled price if compare-at price is missing */
    ready(function () {
      $$('.bls__product-price').forEach(function (box) {
        if (find(box, '.compare-price').length) return;
        var txt = textOf(find(box, '.money, .price__regular .price')).trim();
        var m = txt.match(/([^\d]+)([\d.,]+)/);
        if (!m) return;
        var price = parseFloat(m[2].replace(',', ''));
        if (isNaN(price)) return;
        var html = '\n            <div class=" grey-color">\n              <span>\n                <s class="price-item compare-price">' +
          m[1] + (price * 2).toFixed(2) + '</s>\n              </span>\n            </div>';
        find(box, '.price__regular').forEach(function (reg) { reg.insertAdjacentHTML('afterend', html); });
      });
    });

    /* Convert .price_usd values to the active currency */
    ready(function () {
      var symbols = { USD: '$', EUR: '€', GBP: '£', AUD: 'AUD $', CAD: 'CAD $' };
      var cur = window.Shopify && Shopify.currency && Shopify.currency.active;
      if (!cur || cur === 'USD') return;
      var rate = Shopify.currency.rate;
      var symbol = symbols[cur];
      if (typeof symbol === 'undefined') return;
      $$('.price_usd').forEach(function (el) {
        var v = parseFloat(el.textContent);
        if (!isNaN(v)) el.textContent = (v * rate).toFixed(1);
      });
      $$('.price_currency').forEach(function (el) { el.textContent = symbol; });
    });

    /* Move the "% off" label next to the price */
    onLoad(function () {
      setTimeout(function () {
        var labels = $$('.bls__product-label-detail.percent');
        var prices = $$('.bls__product-details-infor .bls__product-price');
        if (!labels.length || !prices.length) return;
        prices.forEach(function (p) {
          labels.forEach(function (l) { p.appendChild(l.cloneNode(true)); });
        });
        hide(labels);
      }, 1000);
    });

    /* Vitals Volume Discounts: show "Buy 4" / "Buy 5" behind "Show more options" */
    ready(function () {
      function handle() {
        $$('.Vtl-VolumeDiscountRadio__TierList').forEach(function (list) {
          var items = Array.prototype.slice.call(list.children);
          var next = list.nextElementSibling;
          if (items.length <= 3 || (next && next.classList.contains('show-more-options'))) return;
          hide(items.slice(3));
          var more = document.createElement('div');
          more.className = 'show-more-options';
          more.textContent = 'Show more options';
          list.after(more);
          more.addEventListener('click', function () {
            items.slice(3).forEach(function (i) { i.style.display = ''; });
            more.remove();
          });
        });
      }
      var obs = new MutationObserver(function () {
        if (document.querySelector('.Vtl-VolumeDiscountRadio__TierList')) {
          handle();
          obs.disconnect();
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
    });

    /* Vitals BOGO (mobile product page): move its Add to cart button under the product list */
    ready(function () {
      var isProduct = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//i.test(location.pathname);
      if (!isProduct || !window.matchMedia('(max-width: 768px)').matches) return;
      var obs = new MutationObserver(function () {
        var btn = document.querySelector('.vtl-ub-bogo-box__add-to-cart');
        var list = document.querySelector('.vtl-ub-bogo-box__product-list');
        if (!btn || !list) return;
        obs.disconnect();
        setTimeout(function () {
          var b = document.querySelector('.vtl-ub-bogo-box__add-to-cart');
          var l = document.querySelector('.vtl-ub-bogo-box__product-list');
          if (b && l) l.after(b);
        }, 500);
      });
      obs.observe(document.body, { childList: true, subtree: true });
    });

    /* Backup: redirect to /cart 5 seconds after Add to cart */
    ready(function () {
      $$('.add-cart-button.product-form__submit').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setTimeout(function () { window.location.href = '/cart'; }, 5000);
        });
      });
    });

    /* Quantity never 0; hide theme quantity when a Rapi bundle is on the page */
    ready(function () {
      setInterval(function () {
        $$('.quantity__input').forEach(function (i) {
          if (parseInt(i.value, 10) === 0) i.value = 1;
        });
        if (document.querySelector('.rapi-bundles')) hide($$('.product-form__quantity'));
      }, 1000);
    });

    /* Show chat widgets after 10 seconds (not on /cart) */
    ready(function () {
      if (window.location.pathname.indexOf('/cart') !== -1) return;
      setTimeout(function () { show($$('#shopify-chat, #__helpdesk-channel')); }, 10000);
    });

    /* Product with $0 price fix */
    ready(function () {
      var regular = $$('.bls__product-price .price__regular .price');
      var p = parseFloat(textOf(regular).trim().replace(',', '.').replace(/[^0-9.-]+/g, ''));
      if (p == 0) {
        var sale = $$('.bls__product-price .price__sale .price-item');
        hide(sale);
        var presale = textOf(sale).trim();
        regular.forEach(function (el) { el.textContent = presale; });
        hide($$('.product-form__buttons'));
      }
    });

    /* Gift items on the cart page: price = FREE, quantity locked */
    ready(function () {
      var free = '<span class="price special-price"><span class="money notranslate">FREE</span></span>';
      setInterval(function () {
        $$('tr.cart-item:not(.gift-processed)').forEach(function (item) {
          item.classList.add('gift-processed');
          if (textOf(find(item, '.product-option dt')).trim().toLowerCase().indexOf('gift') === -1) return;
          hide(find(item, '.cart-item__details .cart-item__price-wrapper, .product-option-property, .price--end'));
          find(item, '.cart-item__price-wrapper .product-option span, .price--end').forEach(function (e) { e.classList.add('compare-price'); });
          find(item, '.cart-item__price-wrapper .product-option, .cart-item__totals .cart-item__price-wrapper').forEach(function (e) { e.insertAdjacentHTML('afterbegin', free); });
          find(item, 'quantity-input button, quantity-input input').forEach(function (e) { e.disabled = true; });
        });
      }, 1000);
    });
  }

  ready(start);
})();
